<template>
  <div>
    <!-- 商品类目 -->
    <el-dialog title="商品类目" :visible.sync="goodsCategoryDialog" width="500px"
     @close="handleDialogClose"
    >
      <div><el-checkbox @change="allCheck"></el-checkbox> 全选</div>
      <div class="tree-box">
        <el-tree
          :data="list"
          show-checkbox
          default-expand-all
          node-key="id"
          ref="vuetree"
          highlight-current
          :props="defaultProps"
          :default-checked-keys="checkedClass"
          @check-change="handleCheckChange"
        ></el-tree>
      </div>
      <div class="classTotal">已添加 <span :style="{color:globalBG}">{{checkedList.length}}</span> 个类目</div>
      <div style="text-align:right" class="btn-group">
        <el-button @click="handleDialogClose">取消</el-button>
        <el-button @click="handleDialogSure" type="primary">确认</el-button>
      </div>
    </el-dialog>
  </div>  
</template>

<script>
import {getSellercats} from "@/api/analysis/ware-controller"
import {mapState} from "vuex"
export default {
  name: '',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    goodsClass:{
      type: Array,
      default: ()=>[]
    }
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
  },
  data() {
    return {
      goodsCategoryDialog: false,
      checkedClass:[],
      defaultProps: {
        children: "children",
        label: "name"
      },
      list: [],
      checkedList:[],
      allList:[]
    }
  },
  methods: {
    allCheck(val){
      if (val) {
        let arr = this.allList.map(i=>i.id)
        this.$nextTick(function(){
          this.$refs.vuetree.setCheckedKeys(arr);  //"treeList"是你自己在树形控件上设置的 ref="treeList" 的名称
        })
      }else{
          this.$refs.vuetree.setCheckedKeys([]);  //"treeList"是你自己在树形控件上设置的 ref="treeList" 的名称
      }
    },
    handleDialogClose(value) {
      this.$emit("on-close", false);
    },
    handleDialogSure(){
      let data = this.allList.filter(i=>i.isChecked)
      this.$emit("on-close", true,data);
    },
    transverter(data) {
      // 排重
      let obj = {}
      for(let i=0; i<data.length; i++){
        obj[data[i]["categoryId"]] = data[i]
      }
      let arr = Object.values(obj)
      console.log(arr);
      var newData = [];
      for (var i = 0; i < arr.length; i++) {
          newData[i] = {
            id: arr[i].categoryId,
            parent_id: arr[i].parentId,
            name: arr[i].name,
            isChecked:false
          }
      };
      
      return newData;
    },
    handleCheckChange(data, checked, indeterminate){
      if(data.children.length==0 && checked){
        // this.checkedList.push(data)
        let index = this.allList.indexOf(data)
        // console.log(this.allList.indexOf(data));
        this.allList[index].isChecked = true

      }
      if(data.children.length==0 && !checked){
        let index = this.allList.indexOf(data)
        this.allList[index].isChecked = false
      }
      this.checkedList = this.allList.filter(i=>i.isChecked)

    },
    getTrees(list, parent_id = 0) {
      let parentObj = {};
      list.forEach(o => {
        parentObj[o.id] = o;
      })
      if(!parent_id){
        return list.filter(o => !parentObj[o.parent_id]).map(o => (o.children = this.getTrees(list, o.id), o));
      }else{
        return list.filter(o => o.parent_id == parent_id).map(o => (o.children = this.getTrees(list, o.id), o));
      }
    }
  },
  mounted(){
    
    getSellercats().then(res=>{
      let data = this.transverter(res.data)
      this.getTrees(data)
      console.log(data);
      this.list = data.filter(item=>item.parent_id==0)
      // 所有的子节点
      this.allList = data.filter(item=>item.children.length ==0)
      // console.log(this.list);
    });

  },
  watch: {
    value(value) {
      this.goodsCategoryDialog = value
      if(value==true){
      console.log(this.goodsClass);
          let arr = []
        if(this.goodsClass.length!=0){
          arr = this.goodsClass.map(i=>i.id)
        }
        console.log(arr);
        this.$nextTick(function(){
          this.$refs.vuetree.setCheckedKeys(arr);  //"treeList"是你自己在树形控件上设置的 ref="treeList" 的名称
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.classTotal{
  background: #f4f4f4;
  padding: 8px;
}
.tree-box{
  max-height: 300px;
  overflow: auto;
}
.btn-group{
  text-align: right;
  .el-button{
    width: 96px;
  }
}
</style>
